<template>
  <div>
    <Navigation />
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 mt-5">
              <span class="page-block--title">Organizations</span>
              <hr/>
                
                <br />
              <span class="page-block--title">Create An Organization</span>
              <hr/>
              
              
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Settings",
  components: {
  },
  mounted() {},
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
};
</script>
